import { create } from "zustand";
import type { INotification } from "@/types/notification";

interface NotificationState {
  items: INotification[];
  unreadCount: number;
  setNotifications: (items: INotification[]) => void;
  addNotification: (n: INotification) => void;
  setUnreadCount: (count: number | ((prev: number) => number)) => void;
  markAsRead: (id: string) => void;
}

export const useNotificationStore = create<NotificationState>((set) => ({
  items: [],
  unreadCount: 0,
  setNotifications: (items) => set({ items }),
  addNotification: (n) =>
    set((state) => ({
      items: [n, ...state.items].slice(0, 10),
      unreadCount: state.unreadCount + 1,
    })),
  setUnreadCount: (countOrFn) =>
    set((state) => ({
      unreadCount:
        typeof countOrFn === "function"
          ? countOrFn(state.unreadCount)
          : countOrFn,
    })),
  markAsRead: (id) =>
    set((state) => ({
      items: state.items.map((n) => (n.id === id ? { ...n, read: true } : n)),
      unreadCount: Math.max(state.unreadCount - 1, 0),
    })),
}));
